import { z } from 'zod';

import { endpoint } from '@/services/api/endpoint';
import { UserProfileResponseSchema } from '@/domain/env/schemas';

export const envApi = {
  // The caller's own public address, as the server sees it. Answers with the
  // bare address string.
  getUserIP: endpoint({
    method: 'GET',
    url: 'getUserIP',
    response: z.string(),
  }),

  // The signed-in user's profile per app, read once at sign-in.
  getUserProfile: endpoint({
    method: 'GET',
    url: 'getUserProfile',
    response: UserProfileResponseSchema,
  }),
};
